module.exports = __webpack_public_path__ + "img/georadar.95ad580a.png";